import React, { useState } from "react";
import { Button, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import { useOnboardingPromotionPage } from "../../../../hooks/useOnboardingPromotionPage";
import {
  MktVersionTypes,
  versionToPathPrefix,
} from "../../../../components/mkt/mktVersionUtils";

export default function Start_8_V6({
  version = "v6",
}: {
  version?: MktVersionTypes;
}) {
  const navigate = useNavigate();

  const pageKey = "start_8";
  const { singleSelectionId, updateSingleSelection } =
    useOnboardingPromotionPage({
      pageKey,
    });
  const [selected, setSelected] = useState<number | null>(
    singleSelectionId ?? null
  );

  const handleOptionSelect = (optionId: number) => {
    setSelected(optionId);
    updateSingleSelection(optionId);
    setTimeout(() => {
      navigate(`/${versionToPathPrefix(version)}-onboarding/start/9`, {
        replace: true,
      });
    }, 300);
  };

  return (
    <Stack spacing={5} sx={{ paddingBottom: "80px" }}>
      <CustomTypography
        variant="Subtitle"
        fontWeight={500}
        sx={{ color: theme.vars.palette.Content.Strong }}
      >
        {
          "건강한 마음을 되찾기 위해 시간과 노력, 비용을 투자하는 것에 대해 어떻게 생각하나요?"
        }
      </CustomTypography>

      <Stack direction={"column"} sx={{ width: "100%", gap: 1 }}>
        <Button
          fullWidth
          variant={"SingleSlim"}
          size={"lg"}
          color={selected === 1 ? "primary" : "secondary"}
          sx={{ transition: "background-color 0.3s ease" }}
          onClick={() => handleOptionSelect(1)}
        >
          마땅히 치러야 하는 대가이다
        </Button>
        <Button
          fullWidth
          variant={"SingleSlim"}
          size={"lg"}
          color={selected === 2 ? "primary" : "secondary"}
          sx={{ transition: "background-color 0.3s ease" }}
          onClick={() => handleOptionSelect(2)}
        >
          굳이 투자하고 싶지 않다
        </Button>
      </Stack>
    </Stack>
  );
}
